import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Grid,
  TextField,
  Typography,
  Box,
  Paper,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
} from "@mui/material";
import { useState } from "react";
import { Link, Link as RouterLink } from "react-router-dom";
import BoxedLayout from "../../components/common/BoxedLayout";
import { login, verifyOTP } from "../../services/authService";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import { handleUserTermsCondition } from "../../services/dataService";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TermsAndCond from "../../assets/pdf/Terms of Service - ATA Impex -clean[54].pdf";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0971f1",
      darker: "#053e85",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
  },
});
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [credentials, setCredentials] = useState({
    LoginId: "",
    Password: "",
  });
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [otp, setOTP] = useState("");
  const [resp, setResp] = useState({});
  const [open, setOpen] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleInputChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });

  };

  const handleAccept = (e) => {
    setAcceptTerms(!acceptTerms);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await login(credentials);
      const userToken = jwt_decode(response.token);
      setResp(response);
      if (userToken["TermsConditionFlag"] === "False") {
        setAcceptTerms(false);
        setOpen(true);
      } else {
        if (
          userToken["IsMFA"] === "True" &&
          userToken["IsOTPRequired"] === "True"
        ) {
          setStep(1);
        } else {
          localStorage.setItem("_impr", response.role);
          localStorage.setItem("_imp_at", response.token);
          window.location.reload();
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAcceptTerms(false);
    setOpen(false);
  };

  const handleOTP = async () => {
    setLoading(true);
    try {
      const user = jwt_decode(resp.token);
      await verifyOTP(user["UserId"], otp);
      localStorage.setItem("_impr", resp.role);
      localStorage.setItem("_imp_at", resp.token);
      window.location.reload();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("OTP is expired or invalid");
    }
  };

  const handleTermsCondition = async () => {
    try {
      const userToken = jwt_decode(resp.token);
      await handleUserTermsCondition(userToken["UserId"], resp.token);
      if (
        userToken["IsMFA"] === "True" &&
        userToken["IsOTPRequired"] === "True"
      ) {
        setStep(1);
      } else {
        localStorage.setItem("_impr", resp.role);
        localStorage.setItem("_imp_at", resp.token);
        window.location.reload();
      }
      handleClose();
    } catch (error) {
    }
  };

  return (
    <>
      <Dialog maxWidth={"lg"} open={open} onClose={handleClose} fullWidth>
        <DialogTitle
          typography="h4"
          sx={{ p: 3, pt: 4, color: "#2584FF", textAlign: "center" }}
        >
          Terms and Conditions
        </DialogTitle>
        <DialogContent
          sx={{ m: 2, p: 4, pt: 2, height: "500px", background: "#F8F8F8" }}
        >
          <object
            data={TermsAndCond}
            type="application/pdf"
            width="100%"
            height="100%"
          >
            <p>
              Terms and Conditions{" "}
              <a href={TermsAndCond}>click here to download</a>
            </p>
          </object>
        </DialogContent>
        <Grid sx={{ ml: 4 }}>
          <Checkbox onChange={handleAccept} />
          <span>I agree to the Terms & Conditions</span>
        </Grid>
        <DialogActions sx={{ pl: 4, mr: 2, mb: 2 }}>
          <ThemeProvider theme={theme}>
            <Button
              variant="contained"
              color="primary"
              disabled={!acceptTerms}
              onClick={handleTermsCondition}
            >
              Accept
            </Button>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <Grid
          item
          xs={false}
          lg={6}
          sm={4}
          md={6}
          sx={{
            backgroundImage: "url(./img/auth.svg)",
            backgroundRepeat: "no-repeat",
            bgcolor: "background.default",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={6} lg={6} component={Paper} square>
          <BoxedLayout>
            <Typography component="h4" variant="h5">
              {step === 0 ? "Login" : "OTP"}
            </Typography>
            <Box marginTop={3} noValidate>
              <form onSubmit={handleLogin}>
                <TextField
                  margin="normal"
                  variant="outlined"
                  required
                  value={credentials.LoginId}
                  fullWidth
                  id="LoginId"
                  label={"Login ID"}
                  name="LoginId"
                  onChange={handleInputChange}
                  disabled={step === 1}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  required
                  id="Password"
                  name="Password"
                  label={"Password"}
                  value={credentials.Password}
                  type={showPassword ? "text" : "password"}
                  onChange={handleInputChange}
                  disabled={step === 1}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleShowPassword} edge="end">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {step === 1 && (
                  <TextField
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    id="OTP"
                    label={"OTP (Sent to registered email)"}
                    value={otp}
                    autoFocus
                    onChange={(e) => setOTP(e.target.value)}
                  />
                )}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <Link
                    component={RouterLink}
                    to={"forgot-password"}
                    variant="body2"
                  >
                    Forgot Password?
                  </Link>
                </Box>
                {step === 0 && (
                  <LoadingButton
                    type="submit"
                    size="large"
                    id="login-btn"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3 }}
                    loading={loading}
                  >
                    Log In
                  </LoadingButton>
                )}
              </form>
              {step === 1 && (
                <LoadingButton
                  type="submit"
                  size="large"
                  id="login-btn"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3 }}
                  onClick={handleOTP}
                  loading={loading}
                >
                  Verify
                </LoadingButton>
              )}

            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <Typography
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "#0052CC",
                }}
              >
                <Link
                  component={RouterLink}
                  to={"privacy-policy"}
                  variant="body2"
                  target="_blank"
                >
                  Privacy Policy
                </Link>
              </Typography>
            </Box>
          </BoxedLayout>
        </Grid>
      </Grid>
    </>
  );
};

export default Login;



